import { ADD_SNACKBAR_NOTIFICATION, REMOVE_SNACKBAR_NOTIFICATION } from 'reducers/actions-types';

export default {
    /**
     * @param {INotification} notification
     * @return {{notification: INotification, type: *}}
     */
    add({ notification }) {
        return { type: ADD_SNACKBAR_NOTIFICATION, notification };
    },

    /**
     * @param {INotification} notification
     * @return {{notification: notification, type: *}}
     */
    remove({ notification }) {
        return { type: REMOVE_SNACKBAR_NOTIFICATION, notification };
    },
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/snackbar/actions.js